<template>
  <div class="aside-menu-p">
    <template v-for="(sectionList, id) in sections">
      <section v-if="sectionList.length" :key="id" :class="[id]">
        <div
          v-for="item in sectionList"
          :key="`${id}-${item.type}-${item.id}`"
          class="menu-item flex items-center text-lg h-base px-base"
          :class="[item.status]">
          <router-link
            :to="{name: item.type, params: {id: item.id}}"
            class="px-sm"
            @click.native="handleMenuClick">
            {{item.title}}
          </router-link>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'AsideMenuPublic',
  computed: {
    ...mapState(['user', 'menu']),
    sections () {
      return { internal: this.internalList, public: this.publicList }
    },

    // Ensure we always have a menu object
    safeMenu () {
      return this.menu || { public: {}, internal: {} }
    },

    internalList () {
      return Object.entries(this.menu.internal || {})
        .map(([id, item]) => ({ ...item, id, status: 'internal' }))
        .sort((a, b) => a.order - b.order)
    },

    publicList () {
      // Always return at least the Blogs item, regardless of Firebase data
      const blogsItem = {
        type: 'resident-blogs',
        id: 'resident-blogs',
        title: 'Blogs',
        order: 1
      }

      // Curated public menu from Firebase (pages + programmes already chosen for the menu)
      let firebaseItems = []
      if (this.menu && this.menu.public) {
        firebaseItems = Object.entries(this.menu.public)
          .map(([id, item]) => ({ ...item, id: item.id || id }))
          .sort((a, b) => a.order - b.order)
      }

      // Add Subscribe
      const subscribeItem = {
        type: 'subscribe',
        id: 'subscribe',
        title: 'Subscribe',
        order: 999
      }

      // Keep first occurrence only — prevents any double entries in the left menu
      const seen = new Set()
      return [blogsItem, ...firebaseItems, subscribeItem].filter(item => {
        const key = `${item.type}:${item.id}`
        if (!item.id || seen.has(key) || seen.has(item.id)) return false
        seen.add(key)
        seen.add(item.id)
        return true
      })
    }
  },

  watch: {
    user () {
      this.updateMenuSubscription()
    },
    menu () {
      this.$emit('updated')
    }
  },

  created () {
    this.updateMenuSubscription()
  },

  methods: {
    ...mapActions(['updateMenuSubscription']),
    handleMenuClick () {
      // Emit event to parent to close sidebar
      this.$emit('menu-item-clicked')
    }
  }
}
</script>
<!--suppress CssInvalidAtRule -->
<style lang="scss">

</style>
